import PreviredIndicators from './PreviredIndicators';

export default PreviredIndicators;
